import React from 'react';
import { HistoryItem } from '../../../api/cafAutomation';
import { formatWhen } from '../format';
import { MSG_NOT_CONFIRMED, isClash } from '../saveEngine';
import { historyLine, personName } from './automationCopy';

/** A refused save, with Reload when someone else changed the record first (what was typed is kept). */
export const SaveProblem: React.FC<{ message: string; onReload?: () => void }> = ({ message, onReload }) => {
  if (!message) return null;
  return (
    <div className="cur-alert cur-alert--error" role="alert">
      <span className="cur-grow">{message}</span>
      {onReload && (isClash(message) || message === MSG_NOT_CONFIRMED) && (
        <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" onClick={onReload}>Reload</button>
      )}
    </div>
  );
};

export const NoteField: React.FC<{
  id: string; value: string; onChange: (value: string) => void; disabled?: boolean; placeholder?: string;
}> = ({ id, value, onChange, disabled = false, placeholder }) => (
  <div className="cur-field">
    <label htmlFor={id}>Note <span className="cur-opt">(optional)</span></label>
    <textarea id={id} className="cur-input" rows={2} maxLength={2000} value={value} disabled={disabled}
      placeholder={placeholder} onChange={(event) => onChange(event.target.value)} />
    <span className="cur-hint">History records who did this and when.</span>
  </div>
);

/** "what", then "date · who", newest first, with the note when one was given. Names, never email addresses. */
export const HistoryList: React.FC<{
  items: HistoryItem[] | null; problem: string; workflowId?: string; empty: string;
}> = ({ items, problem, workflowId, empty }) => {
  if (problem) return <p className="cur-hint">{problem}</p>;
  if (!items) return <p className="cur-hint">Loading…</p>;
  if (!items.length) return <div className="cur-empty">{empty}</div>;
  return (
    <ol className="cur-timeline">
      {items.map((item, index) => (
        <li key={`${item.kind}-${item.at}-${index}`} className="cur-tl">
          <span className="cur-tl-dot" aria-hidden="true" />
          <div className="cur-tl-head">
            <strong>{historyLine(item, workflowId)}</strong>
            <span className="cur-muted">{`${item.at ? formatWhen(item.at) : ''}${item.at ? ' · ' : ''}${personName(item.by)}`}</span>
          </div>
          {item.note && <div className="cur-tl-reason">{item.note}</div>}
        </li>
      ))}
    </ol>
  );
};
